(function () {
  'use strict';

  const UPDATE_EVENT = 'dr:cart-store-updated';
  const subscribers = new Set();
  let revision = 0;
  let state = {
    cart: null,
    sections: {},
    fingerprint: 'empty',
    source: 'init',
    reason: 'init',
    updatedAt: 0,
    revision: 0,
  };

  function normalizeSections(sections) {
    if (!sections || typeof sections !== 'object') return {};
    return Object.keys(sections).reduce((acc, key) => {
      if (typeof sections[key] === 'string' && sections[key]) {
        acc[key] = sections[key];
      }
      return acc;
    }, {});
  }

  function extractDiscountCodes(cart) {
    const found = [];
    const cartLevel = cart?.cart_level_discount_applications || cart?.discount_applications || [];
    cartLevel.forEach((discount) => {
      found.push(discount?.code || discount?.title || '');
    });
    (cart?.items || []).forEach((item) => {
      (item.discounts || []).forEach((discount) => {
        found.push(discount?.code || discount?.title || '');
      });
      (item.line_level_discount_allocations || []).forEach((allocation) => {
        const application = allocation?.discount_application || allocation;
        found.push(application?.code || application?.title || '');
      });
      (item.discount_allocations || []).forEach((allocation) => {
        const application = allocation?.discount_application || allocation;
        found.push(application?.code || application?.title || '');
      });
    });
    return found
      .map((code) => String(code || '').trim().toUpperCase())
      .filter(Boolean)
      .filter((code, index, list) => list.indexOf(code) === index);
  }

  function buildFingerprint(cart) {
    if (!cart || !Array.isArray(cart.items)) return 'empty';
    return JSON.stringify({
      itemCount: Number(cart.item_count) || 0,
      totalPrice: Number(cart.total_price) || 0,
      discounts: extractDiscountCodes(cart),
      items: cart.items.map((item) => ({
        variantId: Number(item.variant_id) || 0,
        quantity: Number(item.quantity) || 0,
        linePrice: Number(item.final_line_price ?? item.original_line_price ?? 0) || 0,
      })),
    });
  }

  function notify() {
    const snapshot = getSnapshot();
    subscribers.forEach((listener) => {
      try {
        listener(snapshot);
      } catch (err) {
        console.error('[DR Cart Store] Subscriber failed:', err);
      }
    });
    document.dispatchEvent(
      new CustomEvent(UPDATE_EVENT, {
        detail: snapshot,
      })
    );
  }

  function getSnapshot() {
    return {
      ...state,
      sections: { ...state.sections },
      cart: state.cart ? { ...state.cart, sections: { ...state.sections } } : null,
    };
  }

  function replaceCart(cart, meta = {}) {
    if (!cart || typeof cart !== 'object') return getSnapshot();
    const incomingSections = normalizeSections(meta.sections || cart.sections || {});
    const nextSections = meta.replaceSections === false
      ? { ...state.sections, ...incomingSections }
      : { ...incomingSections };
    const nextCart = { ...cart, sections: nextSections };
    revision += 1;
    state = {
      cart: nextCart,
      sections: nextSections,
      fingerprint: buildFingerprint(nextCart),
      source: meta.source || 'unknown',
      reason: meta.reason || 'replace-cart',
      updatedAt: Date.now(),
      revision,
    };
    notify();
    return getSnapshot();
  }

  function mergeSections(sections, meta = {}) {
    const incomingSections = normalizeSections(sections);
    if (!Object.keys(incomingSections).length) return getSnapshot();
    revision += 1;
    const nextSections = { ...state.sections, ...incomingSections };
    const nextCart = state.cart ? { ...state.cart, sections: nextSections } : null;
    state = {
      cart: nextCart,
      sections: nextSections,
      fingerprint: nextCart ? buildFingerprint(nextCart) : state.fingerprint,
      source: meta.source || state.source,
      reason: meta.reason || 'merge-sections',
      updatedAt: Date.now(),
      revision,
    };
    notify();
    return getSnapshot();
  }

  function subscribe(listener) {
    if (typeof listener !== 'function') return function noop() {};
    subscribers.add(listener);
    return function unsubscribe() {
      subscribers.delete(listener);
    };
  }

  window.drCartStore = {
    UPDATE_EVENT,
    subscribe,
    getSnapshot,
    getCart() {
      return state.cart;
    },
    getSections() {
      return { ...state.sections };
    },
    replaceCart,
    mergeSections,
    buildFingerprint,
  };
})();
